import React, { useEffect } from "react";
import { useNavigate, useNavigationType } from "react-router-dom";

const Failed = () => {
  let navigate = useNavigate();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType !== "PUSH") {
      navigate("/payment-failed", { state: { paymentStatus: true } });
    }
  }, [navType, navigate]);
  return <></>;
};

export default Failed;
